<template>
  <div class="smb-sales_container">
    <div class="smb-sales_container_title">
      Select Country/Region
    </div>
    <div class="smb-sales_container_content">
      <el-form
        ref="form"
        label-position="top"
        :model="formData"
        :rules="rules"
        :validate-on-rule-change="false"
        :disabled="isEdit && !isSenior"
      >
        <div class="smb-sales_grid grid-1x2 gap_80">
          <el-form-item prop="country">
            <template #label>
              <div class="smbsales-label_required">
                Business Registration Country/Region
              </div>
            </template>
            <el-select
              v-model="formData.country"
              placeholder=""
              filterable
              style="width: 100%"
              default-first-option
              @change="handleRegisterCountryChange"
              :disabled="isResubmit"
            >
              <el-option
                v-for="(item, index) in countryList"
                :key="index"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <template #label>
              <div class="smbsales-label_required">
                Authorized Country/Region
              </div>
            </template>
            <div class="smb-sales_grid grid-1x2 gap_11">
              <el-form-item prop="authorizedCountry">
                <el-select
                  v-model="formData.authorizedCountry"
                  placeholder=""
                  clearable
                  filterable
                  style="width: 100%"
                  default-first-option
                  @change="handleCountryChange"
                  multiple
                >
                  <el-option
                    v-for="(item, index) in countryList"
                    :key="index"
                    :label="item.name"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
              <el-form-item prop="authorizedRegion">
                <el-select
                  v-model="formData.authorizedRegion"
                  placeholder=""
                  clearable
                  filterable
                  style="width: 100%"
                  default-first-option
                  :disabled="!isCanSelectCity"
                  @change="handleSelectCityChange"
                  multiple
                >
                  <el-option
                    v-for="(item, index) in cityList"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                    :disabled="formData.authorizedRegion.includes(0) && item.id !== 0"
                  />
                </el-select>
              </el-form-item>
            </div>
          </el-form-item>
        </div>
        <div class="smb-sales_tips">
          <img
            src="@/assets/tool-tip_icon.svg"
            width="18px"
            height="18px"
            alt=""
          />
          <div class="smb-sales_desc">
            Business registration country/region refers to the country/region
            where a campany is registered. Authorized country/region refers to
            the country/regionwhere the company is approved and authorized to
            carry out transaction by Ruijie.
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>
import Api from "@/api";
import { mapMutations, mapState } from "vuex";
import eventBus from "../../../utils/eventBus";

export default {
  name: "selectCountryAndRegion",
  props: {
    mode: {
      type: String,
      default: 'base'
    },
    isApply: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    isRenew: {
      type: Boolean,
      default: false
    },
    isResubmit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: {
        country: "",
        authorizedCountry: [], // 选择的国家
        authorizedRegion: [] // 选择的城市
      },
      authorizedCountryName: [], // 选择的国家的具体信息
      countryList: [],
      cityList: [],
      isCanSelectCity: false
    };
  },
  computed: {
    ...mapState("smbSales", ["selectCountryAndRegion"]),
    rules() {
      return {
        country: [
          {
            required: true,
            message: "please input  business registration",
            trigger: ["change"]
          }
        ],
        authorizedCountry: [
          {
            required: true,
            message: "please input authorized country",
            trigger: ["change"]
          }
        ],
        authorizedRegion: [
          {
            required: this.formData.authorizedCountry.length === 1,
            message: "please input authorized region",
            trigger: ["change"]
          }
        ]
      };
    },
    // 是否是高级编辑
    isSenior() {
      return this.mode === 'senior'
    }
  },
  watch: {
    // 实时更新组件在store的数据
    formData: {
      handler(nextFormData) {
        this.SET_SELECT_COUNTRY_AND_REGION({
          country: nextFormData.country,
          authRegion: nextFormData.authorizedCountry.join(","),
          authRegionName: this.authorizedCountryName,
          // 选择的国家如果大于一个时候那么就不传
          city:
            nextFormData.authorizedCountry.length > 1
              ? ""
              : nextFormData.authorizedRegion.join(",")
        });
      },
      immediate: true,
      deep: true
    },
  },
  methods: {
    ...mapMutations("smbSales", ["SET_SELECT_COUNTRY_AND_REGION"]),
    // 搜索国家 可在搜索之后做一些事情
    async searchCountry(callback) {
      await Api.getAllCountries().then(response => {
        let { status, data } = response.data;
        if (status === "200") {
          this.countryList = data;
          callback && callback();
        }
      });
    },
    // 获取所有城市
    getAllCity(id) {
      Api.getCityByPartentId(id).then(response => {
        let { status, data } = response.data;
        if (status === "200") {
          this.cityList = data || [];
        }
      });
    },
    // 选择注册国家变更的时候
    handleRegisterCountryChange(selectCountryCode) {
      // 虽然挺不喜欢的但是没有办法 这里使用事件公交车 通知其他组件清空掉所属vad，组件名字 partnerContractInfo
      eventBus.$emit('onSelectCountryChange', selectCountryCode)
    },
    // 选择的授权国家变更的时候
    handleCountryChange(selectCountryCodeList) {
      if (selectCountryCodeList.length === 1) {
        let country = this.countryList.find(
          item => item.code === selectCountryCodeList[0]
        );
        this.getAllCity(country.id);
        this.isCanSelectCity = true;
      } else {
        this.isCanSelectCity = false;
        this.cityList = [];
        this.formData.authorizedRegion = [];
      }
      this.authorizedCountryName = this.countryList
        .filter(item => selectCountryCodeList.includes(item.code))
        .map(item => item.name)
        .join(",");
    },
    // 设置国家和授权国家为用户的国家
    setAuthorizedCountryForUser() {
      let userCountry = this.countryList.find(
        item => item.name === this.$store.state.user.country
      );
      if (userCountry) {
        this.formData.authorizedCountry = [userCountry.code];
        this.authorizedCountryName = userCountry.name;
        this.formData.country = userCountry.code;
        this.authorizedCountryName = this.countryList
          .filter(item => this.formData.authorizedCountry.includes(item.code))
          .map(item => item.name)
          .join(",");
        this.formData.authorizedRegion = [0]; // 城市默认ALL:0
        this.isCanSelectCity = true;
        this.getAllCity(userCountry.id);
      }
    },
    // 设置formData
    setFormData(nextFormData) {
      if (!nextFormData) return;
      const formData = JSON.parse(JSON.stringify(nextFormData));
      this.formData = {
        country: formData.country,
        authorizedCountry: formData.authorizedCountry, // 选择的国家
        authorizedRegion: formData.authorizedRegion // 选择的城市
      };
      this.isCanSelectCity = formData.authorizedCountry.length === 1;
      this.searchCountry(() => {
        if (formData.authorizedCountry.length === 1) {
          let country = this.countryList.find(
            item => item.code === formData.authorizedCountry[0]
          );
          this.getAllCity(country.id);
        }
      });
      this.authorizedCountryName = formData.authorizedCountryName
    },
    // 获取formData
    getFormData() {
      let isPass = false;
      this.$refs.form.validate(isSuccess => {
        isPass = isSuccess;
      });
      if (isPass) {
        return {
          // 注册国家
          country: this.formData.country,
          // 授权区域
          authRegion: this.formData.authorizedCountry.join(","),
          authRegionName: this.authorizedCountryName,
          // 选择的国家如果大于一个时候那么就不传
          // 城市
          city:
            this.formData.authorizedCountry.length > 1
              ? ""
              : this.formData.authorizedRegion.join(",")
        };
      } else {
        return isPass;
      }
    },
    handleSelectCityChange(value) {
      if (value.includes(0)) {
        this.formData.authorizedRegion = [0];
      }
    }
  },
  mounted() {
    if (this.isApply) {
      this.searchCountry(this.setAuthorizedCountryForUser);
    }else {
      this.searchCountry();
    }
  }
};
</script>
<style scoped>
.form-container_customization {
  padding: 0;
  gap: 11px;
}
</style>



// WEBPACK FOOTER //
// src/views/smbSales/components/selectCountryAndRegion.vue